module.exports = __webpack_public_path__ + "static/media/wind-direction.1ee2b833.svg";